var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-n3",staticStyle:{"position":"relative"}},[_c('span',{staticClass:"text-truncate",staticStyle:{"position":"absolute"},style:({ width: _vm.width })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }